function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "\\uC0AC\\uAC01\\uD615_1607",
  "data-name": "\\uC0AC\\uAC01\\uD615 1607",
  width: 7.92,
  height: 18.793,
  rx: 3.96,
  transform: "translate(0 10.207)"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "\\uC0AC\\uAC01\\uD615_1608",
  "data-name": "\\uC0AC\\uAC01\\uD615 1608",
  width: 7.92,
  height: 7.92,
  rx: 3.96
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_2912",
  "data-name": "\\uD328\\uC2A4 2912",
  d: "M85.052,26.8v8.231a3.965,3.965,0,0,1-7.927,0V25.161a3.953,3.953,0,1,0-7.905,0v9.874a3.965,3.965,0,0,1-7.927,0V26.8h0V25.357A11.877,11.877,0,0,1,72.929,13.24h.49A11.877,11.877,0,0,1,85.056,25.357V26.8Z",
  transform: "translate(-49.138 -9.998)"
});

var SvgBrand = function SvgBrand(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4 1",
    width: 35.921,
    height: 29,
    viewBox: "0 0 35.921 29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBrand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/brand.efb8f30c.svg";
export { ForwardRef as ReactComponent };